import React from 'react';
import { PermissionErrorSC } from './permission-error.styled';
import { useDispatch, useSelector } from 'react-redux';
import TStore from '../../../types/store';
import Button from '@hilbi/web-common/components/button';
import { actions } from '../../../store/ducks/twilio';
import { useIntl } from 'react-intl';

interface ParticipantProps {}

const PermissionError: React.FunctionComponent<ParticipantProps> = ({}) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const permissionError = useSelector((state: TStore) => state.twilio.permissionError);

  return permissionError ? (
    <PermissionErrorSC>
      <p>{formatMessage({ id: permissionError })}</p>
      <div className={'buttons'}>
        <Button
          onClick={() => {
            dispatch(actions.setPermissionError(''));
          }}
        >
          {formatMessage({
            id: 'twilio_retry_permissions',
          })}
        </Button>
        <Button
          onClick={() => {
            dispatch(actions.resetTwilioRoom());
          }}
        >
          {formatMessage({
            id: 'twilio_permissions_cancel',
          })}
        </Button>
      </div>
    </PermissionErrorSC>
  ) : null;
};

export default React.memo(PermissionError);
